import React, { useState } from 'react';

import { Button, Image } from 'antd';
import { useNavigate } from 'react-router-dom';

import '../css/login.css';
import LogoMain from '../images/Logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/reducers/sessionReducer';
import { useEffect } from 'react';

// React Login component
const WorkshopLogin = () => {
    const [user_name, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading, error, user, sessionType } = useSelector((state) => state.session);

    const handleLogin = async (e) => {
        e.preventDefault();
        dispatch(loginUser({ user_name, password, session_type: 'workshop' }));
    };
    useEffect(() => {
        if (user && sessionType && sessionType === 'workshop') {
            navigate('/service/work-tickets');
        }
    }, [user]);

    return (
        <div className="login-container">
            <form onSubmit={handleLogin}>
                <div className="logo">
                    <Image src={LogoMain} preview={false} style={{ objectFit: 'contain' }} />
                    <span>Workshop login</span>
                </div>
                <div className="form-wrap">
                    <div className="form-item">
                        <label htmlFor="username">Login</label>
                        <input
                            type="text"
                            placeholder="User Name"
                            id="username"
                            value={user_name}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="error">{error?.type === 'login' ? error.message : ''}</p>}
                    <Button loading={isLoading} type="primary" htmlType="submit">
                        Login
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default WorkshopLogin;
